import {Component, ElementRef, Input} from '@angular/core';
import {PrintDecisionLetterData} from '../../shared/models/request';
import {AbstractPrintComponent} from '../abstract-print/abstract-print.component';

@Component({
  selector: 'app-print-decision-letter',
  template: '',
  styleUrls: ['./print-decision-letter.component.scss']
})
export class PrintDecisionLetterComponent extends AbstractPrintComponent {
  @Input() data: PrintDecisionLetterData;

  constructor(elRef: ElementRef) {
    super(elRef);
  }
}
